import React, { useEffect, useState } from 'react';
import { FullScreenModal } from '../components/FullScreenModal';
import { PillIcon, ClipboardHeartIcon, HeartIcon, SearchIcon, AlertIcon, BookIcon, ChevronRightIcon } from '../components/icons';
type NhsView = 'list' | 'detail';
const NHS_SECTIONS = [{
  title: 'GP',
  items: [{
    id: 'medications',
    title: 'Medications',
    icon: PillIcon,
    tint: 'sky'
  }, {
    id: 'health-record',
    title: 'Health Record',
    icon: ClipboardHeartIcon,
    tint: 'sage'
  }, {
    id: 'my-gp',
    title: 'My GP',
    icon: HeartIcon,
    tint: 'coral'
  }]
}, {
  title: 'NHS Finder',
  items: [{
    id: 'find-pharmacy',
    title: 'Find Pharmacy',
    icon: SearchIcon,
    tint: 'teal'
  }, {
    id: 'find-gp',
    title: 'Find GP',
    icon: SearchIcon,
    tint: 'teal'
  }, {
    id: 'find-ae',
    title: 'Find A&E',
    icon: AlertIcon,
    tint: 'coral'
  }]
}, {
  title: 'NHS Content',
  items: [{
    id: 'health-az',
    title: 'Health A–Z',
    icon: BookIcon,
    tint: 'lilac'
  }, {
    id: 'medications-az',
    title: 'Medications A–Z',
    icon: PillIcon,
    tint: 'lilac'
  }]
}];
const TINT_STYLES: Record<string, {
  soft: string;
  text: string;
}> = {
  sky: {
    soft: 'bg-sky-soft',
    text: 'text-sky-deep'
  },
  sage: {
    soft: 'bg-sage-soft',
    text: 'text-sage-deep'
  },
  coral: {
    soft: 'bg-coral-soft',
    text: 'text-coral-deep'
  },
  teal: {
    soft: 'bg-teal-soft',
    text: 'text-teal-deep'
  },
  lilac: {
    soft: 'bg-lilac-soft',
    text: 'text-lilac-deep'
  }
};
export function NhsScreen({
  open,
  onClose
}: {
  open: boolean;
  onClose: () => void;
}) {
  const [view, setView] = useState<NhsView>('list');
  const [activeItem, setActiveItem] = useState<string | null>(null);
  // Reset to list view when opened
  useEffect(() => {
    if (open) {
      setView('list');
      setActiveItem(null);
    }
  }, [open]);
  const handleItemClick = (id: string) => {
    setActiveItem(id);
    setView('detail');
  };
  return <FullScreenModal open={open} onClose={onClose} onBack={view === 'detail' ? () => setView('list') : undefined} direction="up" eyebrow={view === 'list' ? 'Official services' : undefined} title={view === 'list' ? 'NHS' : undefined} padded={false} resetOnOpen={false} data-id="element-999">
      {view === 'list' && <div className="dhp-fade px-5 pt-2" data-id="element-1000">
          <div className="flex flex-col gap-8" data-id="element-1001">
            {NHS_SECTIONS.map(section => <section key={section.title} data-id="element-1002">
                <h2 className="mb-3 text-[13px] font-bold uppercase tracking-[0.14em] text-ink-soft" data-id="element-1003">
                  {section.title}
                </h2>
                <div className="flex flex-col gap-2.5" data-id="element-1004">
                  {section.items.map(item => {
              const Icon = item.icon;
              const styles = TINT_STYLES[item.tint];
              return <button key={item.id} onClick={() => handleItemClick(item.title)} className="flex w-full items-center gap-3.5 rounded-card border border-line bg-cream px-4 py-3.5 text-left shadow-card transition-all hover:-translate-y-0.5 hover:shadow-card-hover active:scale-[0.98]" data-id="element-1005">
                        <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl ${styles.soft} ${styles.text}`} data-id="element-1006">
                          <Icon size={20} data-id="element-1007" />
                        </span>
                        <span className="min-w-0 flex-1" data-id="element-1008">
                          <h3 className="font-display text-[15px] font-semibold leading-tight text-ink" data-id="element-1009">
                            {item.title}
                          </h3>
                        </span>
                        <ChevronRightIcon size={16} className="shrink-0 text-ink-faint" data-id="element-1010" />
                      </button>;
            })}
                </div>
              </section>)}
          </div>
        </div>}

      {view === 'detail' && <div className="dhp-fade flex h-full flex-col items-center justify-center px-5 text-center" data-id="element-1011">
          <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-linen text-ink-soft" data-id="element-1012">
            <HeartIcon size={32} data-id="element-1013" />
          </div>
          <h2 className="font-display mt-5 text-[22px] font-semibold text-ink" data-id="element-1014">
            {activeItem}
          </h2>
          <p className="mt-2 text-[14.5px] leading-relaxed text-ink-soft" data-id="element-1015">
            This section connects directly to NHS services. It will be available
            in a future update.
          </p>
        </div>}
    </FullScreenModal>;
}